module.exports = __webpack_public_path__ + "img/home-2.94b87d4f.png";